import script from "./InfoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoPage.vue?vue&type=script&setup=true&lang=js"

import "./InfoPage.vue?vue&type=style&index=0&id=5df91d41&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df91d41"]])

export default __exports__